import Vue from 'vue'
import Vuex from 'vuex'
import admin from './modules/admin'
import question from "@/store/modules/question";

Vue.use(Vuex)

export default new Vuex.Store({
  actions: {
  },
  modules: {
    admin,
    question
  }
})
